import React, { Component } from "react";
import {getFormattedDate} from "../../../helper/utils";
import Loader from 'react-loader';
import { getList } from "../../../services/baseServices";

class OrderList extends Component {
    constructor() {
        super();
        this.state = {
            selectedItemsId: [],
            bankList: []
        };
    }

    componentDidMount = () => {

        getList("bank_accounts")
        .then(res => {
            this.setState({bankList: res})
        })
        .catch(errMsg => {
        })
    }

    checkboxHandler = (id = null) => {
        if (id) {
            const {selectedItemsId} = this.state
            const index = selectedItemsId.indexOf(id);
            if (index > -1) selectedItemsId.splice(index, 1);
            else selectedItemsId.push(id)
            this.setState({selectedItemsId}, () => {
                const selectedOrdersAmount = this.props.orderList.filter(item =>(
                    selectedItemsId.includes(item.id)
                )).reduce((total, item) =>(
                        total + +item.amount
                ), 0)
                console.log(this.props.orderList.filter(item =>(
                    selectedItemsId.includes(item.id)
                )))
                console.log(selectedOrdersAmount, selectedItemsId)
                this.props.onCheckedOrder(selectedItemsId, selectedOrdersAmount)
            })
        }
    }

    render() {
        const {orderList, isLoading} = this.props
        return (
            <Loader loaded={!isLoading}>
                <div className="card-block">
                    <div className="block-body">
                        <table className="order-table table table-striped">
                            <thead>
                            <tr>
                                <th>Order Number</th>
                                <th>Reconciled Date</th>
                                <th>Amount</th>
                                <th>Shipping Type</th>
                                <th>Depositted</th>
                            </tr>
                            </thead>
                            <tbody>
                            {orderList?.length > 0 ? (
                                orderList.map((order, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <div className="order-item">
                                                    # {order.id}
                                                </div>
                                            </td>

                                            <td>
                                                <div className="order-item">
                                                    {getFormattedDate(order.reconciled_date, "DD/MM/YY")}
                                                </div>
                                            </td>

                                            <td>
                                                <div className="order-item">
                                                    <h4 className="order-id mb-0">
                                                        {order.amount}
                                                    </h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="order-item">
                                                    <h4 className="order-id mb-0">
                                                        {order.shipping_type}
                                                    </h4>
                                                </div>
                                            </td>

                                            <td>
                                                <div className="order-item">
                                                    {order.is_paid ? "Yes" : "No"}
                                                </div>
                                            </td>

                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={5} className="text-center">
                                        {" "}
                                        <h5>No Order Found</h5>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>

            </Loader>
        );
    }
}

export default OrderList;
